import React from 'react';
import { ValidOption } from '../validSvc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

export type Criteria = Record<string, ValidOption & { checked?: boolean }>;

type SearchCriteriaProps<TSearchModel extends object> = {
    criteria: TSearchModel;
};

const SearchCriteria = <TSearchModel extends object>({ criteria }: SearchCriteriaProps<TSearchModel>): JSX.Element => {
    return (
        <div className="component-search-criteria">
            {Object.keys(criteria).map(key => {
                const prop = criteria[key];
                if (prop?.checked === false) {
                    return null;
                }
                const val = generateCriteriaLabel(prop);
                if (val === null) {
                    return null;
                }
                return (
                    <CriteriaTerm
                        key={key}
                        label={prop.lbl}
                        value={val}
                    />
                );
            })}
        </div>
    );
};

export default SearchCriteria;

const CriteriaTerm = ({ label, value }: { label: string; value: string }): JSX.Element => {
    return (
        <div className="drawer-filter search-criteria-term">
            <FontAwesomeIcon icon={faFilter} />
            &nbsp;
            {label}: &nbsp;
            {value}
        </div>
    );
};

function generateCriteriaLabel(prop: ValidOption & { checked?: boolean; options?: string[] }): string | null {
    if (Array.isArray(prop.val) && prop.val.length === 0) {
        return null;
    }
    if (prop.val !== undefined && prop.val !== '') {
        let val = prop.val;
        if (typeof val === 'boolean') {
            val = val ? 'Yes' : 'No';
        } else if (prop?.options && val.length === prop?.options.length) {
            val = 'All';
        } else if (Array.isArray(prop.val) && prop.val.length > 1) {
            val = `${prop.val.length} options`;
        } else if (Array.isArray(prop.val) && prop.val.length === 1) {
            val = prop.val[0];
        }
        return val;
    }
    return null;
}
